import request from '@/utils/request'

export function getAuthorization(methods, pathname) {
  return request({
    url: 'outer_apis/qcloud/sts_cos_sign',
    method: 'get',
    data: { method: methods, pathname: pathname }
  })
}
